import { render } from "./AddProjectModal.vue?vue&type=template&id=18c9f6d4&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"

import "./AddProjectModal.vue?vue&type=style&index=0&id=18c9f6d4&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c9f6d4"]])

export default __exports__